/**
 * Round 7 Workstream E - counts and their render caps.
 *
 * The backend returns exact counts as { count, shown, exact: true, capped }:
 * `count` is a real count query (742 stays 742), `capped` only says the LIST
 * below it is truncated ("showing 500 of 742"). A count that can ONLY be
 * derived from a capped source (len() of a 500-row page, no count query) is
 * never printed as a bare 500: it renders `500+`.
 */
export function formatCount(block) {
  if (block === null || block === undefined) return "-";
  if (typeof block === "number") return String(block);
  const n = block.count ?? 0;
  return block.exact === false ? `${n}+` : String(n);
}

/** Count derived from a list that may have hit its render cap (no real count
 *  available): `500+` when the list is at/over the cap, else the exact length. */
export function cappedLength(length, cap) {
  return length >= cap ? `${length}+` : String(length);
}

/** "showing 500 of 742" when a list is truncated, else null. */
export function truncationNote(block) {
  if (!block || !block.capped) return null;
  return `showing ${block.shown} of ${block.count}`;
}
